<template>
    <div class="row justify-content-end">
        <div class="col-12 col-md-4">
            <div>
                <table class="table right-table mb-0">
                    <tbody>
                        <tr v-for="(total, index) in totals" :key="index" class=" d-flex align-items-center justify-content-between" >
                            <th class="border-0">
                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark">
                                    {{ index }}:
                                </h5>
                            </th>
                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                {{ total }} {{ currencySymbol }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Total",
    props: ['totals'],
    computed: {
        currencySymbol() {
            return window.appConfig?.currencySymbol || '€';
        }
    }
};
</script>